import ServiceBase from './serviceBase';
import { FlowCommentCreate, FlowCommentsFilter, FlowCommentList } from './types/Flow';

class OperEssCommentsService extends ServiceBase {
  create = async (data: FlowCommentCreate): Promise<void> =>
    this.post<void>('EssComment/create', data);

  getList = async (filter: FlowCommentsFilter): Promise<FlowCommentList> =>
    this.post<FlowCommentList>('esscomment/list', filter);

  exportExcel = async (operationId: number): Promise<boolean> => {
    await this.download(`esscomment/excel/${operationId}`, undefined, true);
    return true;
  };
}

const operEssCommentsService = new OperEssCommentsService();

export default operEssCommentsService;
